import {IService} from "@/model/Service/Service"

export interface IHasServicesIncluded {
    getServicesIncluded(): IService[]
    getServicesIncludedMap(): Map<string, IService>
    addServiceIncluded(service: IService): void
    removeServiceIncluded(service: IService): void
}

function hasServices<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasServicesIncluded {
        private servicesIncluded: IService[] = []
        private servicesIncludedMap: Map<string, IService> = new Map()

        constructor(...args: any[]) {
            super(...args);
        }

        public getServicesIncluded(): IService[] {
            return this.servicesIncluded
        }
        public getServicesIncludedMap(): Map<string, IService> {
            return this.servicesIncludedMap
        }
        public addServiceIncluded(service: IService): void {
            if (this.servicesIncludedMap.has(service.getIdFull())) return
            this.servicesIncluded.push(service)
            this.servicesIncludedMap.set(service.getIdFull(), service)
        }
        public removeServiceIncluded(service: IService): void {
            if (!this.servicesIncludedMap.has(service.getIdFull())) return
            this.servicesIncluded = this.servicesIncluded.filter((existingService: IService) => existingService.getIdFull() !== service.getIdFull())
            this.servicesIncludedMap.delete(service.getIdFull())
        }
    };
}

export default hasServices